import { apiSlice } from "../apiSlice";

export const salesChartDataApi = apiSlice.injectEndpoints({
    endpoints: (builder)=>({
        getCurrMonthWeeklyChartData: builder.query({
            query: ({createdBy})=>`dashboard/current-month-weekly-sales-stat?createdBy=${createdBy}`,
            keepUnusedDataFor:600,
            providesTags: ()=> [{type: 'currMonthWeeklyChartData'}]
        }),
         getLastMonthWeeklyChartData: builder.query({
            query: ({createdBy})=>`dashboard/last-month-weekly-sales-stat?createdBy=${createdBy}`,
            keepUnusedDataFor:600,
            providesTags: ()=> [{type: 'lastMonthWeeklyChartData'}]
        }),
        getLastThreeMonthChartData: builder.query({
            query: ({createdBy})=>`dashboard/last-three-month-sales-stat?createdBy=${createdBy}`,
            keepUnusedDataFor:600,
            providesTags: ()=> [{type: 'lastMonthWeeklyChartData'}]
        }),
    })
})

export const {
    useGetCurrMonthWeeklyChartDataQuery, 
    useGetLastMonthWeeklyChartDataQuery, 
    useGetLastThreeMonthChartDataQuery
} = salesChartDataApi